import styled from 'styled-components';
import images from '../../../images';

const FeedbackContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 100px 35px;
`;

const FeedbackImage = styled.div`
  background-size: contain;
  background-position: center;
  width: 80px;
  height: 80px;

  &.correct{
    background-image: url(${images.correct});
  }
  
  &.wrong{
    background-image: url(${images.wrong});
  }
`;

const FeedbackText = styled.div`
  text-align: center;

  h3 { margin-top: 15px; font-size: 23px; font-weight: normal; }
  p { margin-top: 8px; }
`;

const feedbackState = {
  wrong: (
    <FeedbackContainer>
      <FeedbackImage className="wrong animate__animated animate__wobble" />
      <FeedbackText>
        <h3>Oops!</h3>
        <p>That was close</p>
      </FeedbackText>
    </FeedbackContainer>
  ),
  correct: (
    <FeedbackContainer>
      <FeedbackImage className="correct animate__animated animate__rubberBand" />
      <FeedbackText>
        <h3>Good job!</h3>
        <p>Nice one!</p>
      </FeedbackText>
    </FeedbackContainer>
  ),
  timesup: (
    <FeedbackContainer>
      <FeedbackImage className="wrong" />
      <FeedbackText>
        <h3>Time up!</h3>
        <p>You must act faster.</p>
      </FeedbackText>
    </FeedbackContainer>
  )
};

const Feedback = ({ feedbackStatus }) => (feedbackState[feedbackStatus]);

export default Feedback;
